import { RUN_MODE } from "framework/RCApp";

export interface AppFlavour {
  pilotId: number
  backendApiUrl: string
  environment : string
}

export class AppFlavour {
  static flavour: AppFlavour;

  constructor() {
    this.pilotId = 10082;
    this.environment = "dev";
    this.backendApiUrl = "console-tep-uat.bidgely.com";
  }

  static getFlavour() {
    if(this.flavour) {
      return this.flavour;
    }
    if(typeof (window) === "undefined") {
      this.flavour = new AppFlavour();
      return this.flavour;
    }

    const host = window.location.host;

    if (FlavourSDGE.isDomainSupported(host)) {
      this.flavour = new FlavourSDGE();
    } else if(FlavourENO.isDomainSupported(host)) {
      this.flavour = new FlavourENO();
    } else if(FlavourPowershift.isDomainSupported(host)) {
      this.flavour = new FlavourPowershift();
    } else if(FlavourAmeren.isDomainSupported(host)) {
      this.flavour = new FlavourAmeren();
    } else if(FlavourNVEnergyEV.isDomainSupported(host)) {
      this.flavour = new FlavourNVEnergyEV();
    } else if(FlavourRMPEV.isDomainSupported(host)) {
       this.flavour = new FlavourRMPEV();
    } else if(FlavourTEPEV.isDomainSupported(host)) {
            this.flavour = new FlavourTEPEV();
         } else {
      this.flavour = new AppFlavour();
    }
    return this.flavour;
  }

  static getEnvironmentFromURL(host : string){
    let environment = RUN_MODE.PROD;
    if(host.includes("-dev")){
      environment = RUN_MODE.DEV;
    } else if(host.includes("-uat")){
      environment = RUN_MODE.UAT;
    } else if(host.includes("-nonprodqa")){
      environment = RUN_MODE.QA;
    } else if(host.includes("-productqa")){
      environment = RUN_MODE.PRODUCT_QA;
    }

    return environment
  }

}

class FlavourSDGE extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10082;
    this.backendApiUrl = "console-tep-uat.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-sdge(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}
class FlavourENO extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10090;
    this.backendApiUrl = "console-tep-uat.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-eno(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourPowershift extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10058;
    this.backendApiUrl = "bidgelyevuatapi.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-powershift(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourAmeren extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10057;
    this.backendApiUrl = "herdevapi.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-ameren(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourNVEnergyEV extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10098;
    this.backendApiUrl = "api-server-evmc-uat.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-nvenergyev(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourRMPEV extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10104;
    this.backendApiUrl = "api-server-evmc-uat.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-wattsmartdrive(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class FlavourTEPEV extends AppFlavour {
  constructor() {
    const host = window.location.host;

    super();
    this.pilotId = 10080;
    this.backendApiUrl = "api-server-tep-uat.bidgely.com";
    this.environment = AppFlavour.getEnvironmentFromURL(host);
  }

  static isDomainSupported(host : string) {
    return new RegExp(/^console-tep(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}